import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { getAllDetailsDirect } from '../../../service/ProductService';
import {  DOCUMENTLIST, DOWNLODZIP, FILEDETAIL,  } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { ScrutinyViewDocumentColumnsList } from '../../../appconfig/DatatableSetting';
import { useNavigate, useParams } from 'react-router-dom';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

import { Badge } from 'primereact/badge';
import Loader from '../../../components/Loadeer/Loader';
import { formatDate, setAppStatus } from '../../../appconfig/AppHelper';

export const ViewScrutinyDocument = () => {
    document.title = 'View Document  | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const { fileno, appName }: any = useParams();

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [loader, setLoader] = useState<boolean>(false);

    //verificaion List
    const [documentList, setDocumentList] = useState<any>([]);
    const [userDetails, setUserDetails] = useState<any>({});
    const [appStatus, setApplicationStatus] = useState<any>({});

    // useEffect
    useEffect(() => {
        getAllDocument();
        getUserDetail();
    }, []);

    // Get hospitalList list
    const getAllDocument = async () => {
        try {
            setPageLoad(false);
            const fileNo = atob(fileno);
            const AppName = atob(appName);
            const response = await getAllDetailsDirect(DOCUMENTLIST + '?fileNo=' + fileNo + '&AppName=' + AppName + '&parent_id=' + fileNo);

            if (response) {
                const DataList: any = response?.data?.documents;
                if (DataList.length === 0) {
                    setDocumentList([]);
                } else {
                    setDocumentList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setDocumentList([]);
                setUserDetails({});
            }
        } catch (error: any) {
            setPageLoad(true);
            setDocumentList([]);
            setUserDetails({});
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //getUserDetails c
    const getUserDetail = async () => {
        try {
            setLoader(true);
            const fileNo = atob(fileno);
            const AppName = atob(appName);
            const response = await getAllDetailsDirect(FILEDETAIL + '?fileNo=' + fileNo + '&AppName=' + AppName);

            if (response) {
                setUserDetails(response?.data);
                
                let applicationBadgeInfo = setAppStatus(response?.data?.appStatus);
                setApplicationStatus(applicationBadgeInfo);
                setLoader(false);
            } else {
                setLoader(false);
                setUserDetails({});
            }
        } catch (error: any) {
            setLoader(false);
            setUserDetails({});
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Zip Download" icon="pi pi-file-export" className="p-button p-button-success " onClick={() => getZipLink()} />
                {/* <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button> */}
            </>
        );
    };

    //getZipLink
    const getZipLink = async () => {
        try {
            const fileNo = atob(fileno);
            const AppName = atob(appName);

            const response = await getAllDetailsDirect(DOWNLODZIP + '?fileNo=' + fileNo + '&AppName=' + AppName + '&parent_id=' + fileNo);
            const downloadZip = response.data;

            //Download File Forcefully
            var anchor = document.createElement('a');
            anchor.href = downloadZip;
            anchor.download = downloadZip;
            anchor.click();
        } catch (error) {}
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="">
                    <Button icon="pi pi-eye" tooltip="View " tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => window.open(rowData?.image_url, '_blank')} disabled={!window.cn(rowData?.image_url) ? false : true} />
                </div>
            </>
        );
    };

    //documentTemplat
    const docTemplate = (rowData: any) => {
        return (
            <>
                {rowData.DocName} {rowData.is_required == true ? <span className="errors">*</span> : ''}
            </>
        );
    };

   

    // Get Name
    let name = `${!window.cn(userDetails?.StudL) ? userDetails?.StudL : ''} ${!window.cn(userDetails?.StudF) ? userDetails?.StudF : ''} ${!window.cn(userDetails?.StudM) ? userDetails?.StudM : ''}`;
    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Scrutiny'} pageName={'View Document'} pageTitle={'View Document'} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">

                        <div className="grid pt-2">
                            <div className="field col-12 md:col-4 mb-0">
                                <div className="flex">
                                    <b className="detail_title mr-3">Full Name : </b>
                                    <p className="detail_name">{name}</p>
                                </div>
                            </div>
                            <div className="field col-12 md:col-4 flex justify-content-center mb-0">
                                <div className="flex">
                                    <b className="detail_title mr-3">Status :</b>
                                    <p className="detail_name">{<Badge value={appStatus?.value} severity={appStatus?.severity}></Badge>}</p>
                                </div>
                            </div>

                            <div className="field  col-12 md:col-4 flex justify-content-end mb-0">
                                <div className="flex">
                                    <b className="detail_title mr-3">Date :</b>
                                    <p className="detail_name">{!window.cn(userDetails?.EntDt) ? formatDate(userDetails?.EntDt) : ''}</p>
                                </div>
                            </div>
                        </div>
                        {/* Datatable */}

                        <Toolbar right={rightToolbarTemplate} className='mt-4'></Toolbar>

                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={documentList}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={documentList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {ScrutinyViewDocumentColumnsList.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'DocName') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={docTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ScrutinyViewDocumentColumnsList.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loader && <Loader />}
        </>
    );
};
